import { useEffect, useState, useRef } from "react";
import axios from "../../utils/axiosInstance";

import BasicInput from "../../components/edittext/basicInput/basicInput";
import FileInput from "../../components/edittext/fileInput/fileInput";
import LinearLayout from "../../components/layout/LinearLayout";

import Modal from "../../components/modal/Modal";
import SelectBox from "../../components/edittext/selectbox/SelectBox";
import { ChevronDown, ChevronUp } from "lucide-react";

const Campaign = () => {
  const fileInputRef = useRef(null);
  const [campaigns, setCampaigns] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [expanded, setExpanded] = useState(null);
  // وقتی اسلایدر انتخاب شد، فرم پر بشه
  useEffect(() => {
    if (selectedCampaign) {
      setFormData({
        title: selectedCampaign.title,
        link: selectedCampaign.link,
        status: selectedCampaign.status,
      });
    }
  }, [selectedCampaign]);

  const fetchCampaigns = async ({ page = 1, limit = 10 }) => {
    try {
      setLoading(true);
      const response = await axios.get("/site-content", {
        params: { type: "campaign", page, limit },
      });
      console.log("Campaign", response.data.items);
      return response.data.items;
    } catch (error) {
      console.error("Error fetching Campaign:", error);
      setError("Error Loading data!");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const loadCampaigns = async () => {
    try {
      const data = await fetchCampaigns({ page, limit: perPage });
      setCampaigns(data || []);
      setTotalCount(data.pagination?.total || 0);
    } catch (err) {
      console.error("Error loading sliders:", err);
    }
  };

  useEffect(() => {
    loadCampaigns();
  }, [page, perPage]);
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]); // فایل انتخاب‌شده ذخیره میشه
  };
  const handleEditCampaign = (slider) => {
    setSelectedCampaign(slider);
    setModalOpen(true);
  };
  const handleAddClick = () => {
    setSelectedCampaign(null);
    setModalOpen(true);
  };
  const handleSubmit = () => {
    if (selectedCampaign?._id) {
      handleUpdateCampaign();
    } else {
      handleAddCampaign();
    }
  };
  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("image", selectedFile); // فایلی که کاربر انتخاب کرده
    formData.append("id", selectedCampaign._id); // آیدی محصول مورد نظر

    axios
      .post("/site-content/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Image uploaded:", res.data.item.image);
        if (res.data?.item.image) {
          // آپدیت اسلایدر انتخاب‌شده
          setSelectedCampaign((prev) => ({
            ...prev,
            image: res.data.item.image,
          }));
          setCampaigns((prev) =>
            prev.map((s) =>
              s._id === selectedCampaign._id
                ? { ...s, image: res.data.item.image }
                : s
            )
          );
        }
      })
      .catch((err) => {
        console.error("Upload error:", err);
      });
  };
  const handleUpdateCampaign = async () => {
    try {
      const res = await axios.put(
        `/site-content/${selectedCampaign._id}`,
        formData
      );
      if (res) {
        loadCampaigns();
        setModalOpen(false);
      }
    } catch (err) {
      console.error("Error updating slider:", err);
    }
  };

  const handleAddCampaign = async () => {
    const campaignData = {
      title: formData.title,
      link: formData.link,
      type: "campaign",
    };
    try {
      const res = await axios.post(`/site-content`, campaignData);

      if (res) {
        loadCampaigns();
        setModalOpen(false);
      }
    } catch (err) {
      console.error("Error updating slider:", err);
    }
  };
  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };
  if (loading) return <div className="p-3">⏳Loading...</div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;
  return (
    <div>
      <h2 className="m-4">Manage Sliders</h2>
      <button
        className="btn btn-sm btn-outline-primary m-2"
        onClick={handleAddClick}
      >
        Add
      </button>
      {/* Desktop Table */}
      <div className="d-none d-lg-block m-4">
        <table className="table table-striped w-100 table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Title</th>
              <th>Link</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.map((campaign, index) => (
              <tr key={campaign._id}>
                <td>{(page - 1) * perPage + index + 1}</td>
                <td>
                  <img
                    src={`${campaign.image}`}
                    alt={campaign.title}
                    style={{
                      width: "80px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                </td>
                <td>{campaign.title}</td>
                <td>{campaign.link}</td>
                <td>
                  <span
                    className={`badge ${
                      campaign.status === "active" ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {campaign.status}
                  </span>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-primary me-1"
                    onClick={() => handleEditCampaign(campaign)}
                  >
                    Edit
                  </button>
                  <button className="btn btn-sm btn-danger">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            Showing {(page - 1) * perPage + 1} to{" "}
            {Math.min(page * perPage, totalCount)} of {totalCount} entries
          </div>
          <div className="btn-group">
            <button
              className="btn btn-secondary"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              disabled={page * perPage >= totalCount}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <div className="d-lg-none m-2">
        {campaigns.map((campaign) => (
          <div
            key={campaign._id}
            className="border rounded mb-3 shadow-sm overflow-hidden"
          >
            <div
              className="d-flex justify-content-between align-items-center p-2 bg-light"
              onClick={() => toggleExpand(campaign._id)}
              role="button"
            >
              <div>
                <strong>{campaign.title}</strong>
              </div>
              {expanded === campaign._id ? <ChevronUp /> : <ChevronDown />}
            </div>

            {expanded === campaign._id && (
              <div className="p-2 small bg-white">
                <img
                  src={`${campaign?.image}`}
                  alt="Sliders"
                  className="img-thumbnail"
                />
                <div>
                  <div>
                    <strong>Link:</strong> {campaign.link}
                  </div>
                  <strong>Active:</strong>{" "}
                  <span
                    className={`badge ${
                      campaign.status === "active"
                        ? "bg-success"
                        : campaign.status === "inactive"
                        ? "bg-warning"
                        : "bg-danger"
                    }`}
                  >
                    {campaign.status}
                  </span>
                </div>
                <div>
                  <strong>Created:</strong>{" "}
                  {new Date(campaign.createdAt).toLocaleDateString()}
                </div>
                <div className="mt-2">
                  <button
                    className="btn btn-sm btn-outline-primary me-1"
                    onClick={() => handleEditCampaign(campaign)}
                  >
                    Edit
                  </button>
                  <button className="btn btn-sm btn-outline-danger">
                    Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
        {/* Pagination mobile */}
        <div className="btn-group">
          <button
            className="btn btn-secondary"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <button
            className="btn btn-secondary"
            disabled={page * perPage >= totalCount}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
        <div className="mt-2">
          Showing {(page - 1) * perPage + 1} to{" "}
          {Math.min(page * perPage, totalCount)} of {totalCount} entries
        </div>
      </div>
      {/* Modal ویرایش */}

      <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
        <div style={{ overflowY: "auto", maxHeight: "80vh" }}>
          <LinearLayout orientation="vertical" gap={2}>
            <img
              src={`${selectedCampaign?.image}`}
              alt={selectedCampaign?.title}
              className="img-thumbnail"
            />
            <FileInput
              bsize="2"
              bcolor="primary"
              margin="2"
              bgcolor="white"
              textcolor="black"
              handleFileChange={handleFileChange}
              handleUpload={handleUpload}
            />

            <BasicInput
              text="Title"
              value={formData.title}
              onChange={(val) => setFormData({ ...formData, title: val })}
              bcolor="primary"
              bgcolor="white"
              margin="2"
            />

            <BasicInput
              text="Link"
              value={formData.link}
              onChange={(val) => setFormData({ ...formData, link: val })}
              bcolor="primary"
              bgcolor="white"
              margin="2"
            />
            <LinearLayout>
              <SelectBox
                value={formData.status || "active"}
                onChange={(value) =>
                  setFormData({ ...formData, status: value })
                }
                array={[
                  { _id: "active", name: "Active" },
                  { _id: "inactive", name: "Inactive" },
                ]}
                text="Status"
                bcolor="primary"
                textcolor="dark"
                bgcolor="white"
                margin="2"
              />
            </LinearLayout>
            <button className="btn btn-success mt-3" onClick={handleSubmit}>
              Save Changes
            </button>
          </LinearLayout>
        </div>
      </Modal>
    </div>
  );
};

export default Campaign;
